/* eslint-disable camelcase */
import { IApplicationData } from 'src/interfaces/ApplicationData';
import { ANALYTICS_EVENT } from 'src/interfaces/enums';
import { detectConnectionType } from 'src/utils/browserUtils';
import { PLAYER_NAME, PAGE_TYPE, CDN_LABEL, PROJECT_DEPENDENCIES, SOURCE_TYPE_MAP } from './constants';

class MuxService {
  constructor(protected applicationData: IApplicationData) {
    this.applicationData = applicationData;
  }

  getConfig() {
    const {
      applicationKey,
      userCode,
      muxApiKey,
      mediaCode: code,
      mediaDuration,
      mediaType,
      clubMembershipId,
      mediaAssets,
      experimentName,
      mediaLanguage,
      playerLanguage,
      mediaTitle,
      cdnProvider,
    } = this.applicationData;

    const source = mediaAssets[0]?.url;

    const custom_1 = JSON.stringify({ user: userCode });
    const custom_2 = JSON.stringify({
      emeVersion: PROJECT_DEPENDENCIES.EME,
      muxVersion: PROJECT_DEPENDENCIES.MUX,
      playerVersion: PROJECT_DEPENDENCIES.PLAYER,
      qualityVersion: PROJECT_DEPENDENCIES.QUALITY,
      streamingVersion: PROJECT_DEPENDENCIES.HTTP_STREAMING,
    });

    const muxData = {
      debug: false,
      data: {
        property_key: muxApiKey,

        // Custom Data
        custom_1,
        custom_2,
        experiment_name: experimentName,

        // Player
        page_type: PAGE_TYPE,

        // Player Metadata
        player_name: PLAYER_NAME,
        player_language_code: playerLanguage ? playerLanguage.toUpperCase() : 'undefined',
        player_version: PROJECT_DEPENDENCIES.PACKAGE,

        // Property
        property_id: muxApiKey,
        source_hostname: `${process.env.APP_HOST}`,
        sub_property_id: applicationKey,

        // Video Metadata (cleared with 'videochange' event)
        video_id: code,
        video_duration: mediaDuration,
        video_content_type: mediaType.toLowerCase(),
        video_cdn: CDN_LABEL[cdnProvider],
        video_encoding_variant: experimentName,
        video_language_code: mediaLanguage,
        video_producer: clubMembershipId,
        video_series: clubMembershipId,
        video_source_url: source,
        video_stream_type: this.getStreamType(),
        video_title: mediaTitle || code,
        viewer_connection_type: detectConnectionType(),
        viewer_user_id: userCode,
      },
    };

    return muxData;
  }

  getStreamType() {
    return `${this.applicationData.isDrmEnabled ? 'DRM/' : ''}${this.applicationData.transmissionType}`;
  }

  static getSourceType = (type: string) => SOURCE_TYPE_MAP[type];

  static emitExtraData(
    emitter: Function,
    data: {
      currentSourceType?: string;
      playerInitTime: number;
    },
  ) {
    setTimeout(() => {
      const sourceType = data.currentSourceType && MuxService.getSourceType(data.currentSourceType);
      const custom_3 = JSON.stringify({ sourceType: sourceType });

      return emitter(ANALYTICS_EVENT.LOAD_START, {
        custom_3,
        player_init_time: data.playerInitTime,
      });
    }, 2000);
  }
}

export default MuxService;
